function Quote() {
  return (
    <div style ={{marginTop:'100px',marginLeft:'230px'}}>
      <p
        style={{
          color: "yellow",
          fontFamily: "Palatino, Palatino Linotype, serif",
          fontSize: "20px",
        }}
      >
     
        <i>"Life without drama? Boring! Watch one now—stop scrolling and start streaming"</i>
      </p>
    </div>
  );
}

export default Quote;
